module.exports = __webpack_public_path__ + "img/greyInfo.5bdf450f.svg";